define('GameDayCore/GDUtil/dataMapping/NumberWithOrdinal',['require','exports','module'],function(require,exports,module) {

    return function(num) {
        var label,
            str = num + '',
            lastDigit = str.substr(-2);

        if (lastDigit === '11' || lastDigit === '12' || lastDigit === '13') {
            label = 'th';
        } else {
            switch (~~lastDigit.substr(-1)) {
                case 1:
                    label = 'st';
                    break;
                case 2:
                    label = 'nd';
                    break;
                case 3:
                    label = 'rd';
                    break;
                default:
                    label = 'th';
            }
        }
        return num + label;
    }
});
